import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchBodyPartOneVehicleInformationFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPartOneVehicleInformation/patchBodyPartOneVehicleInformationFunction';
import { PatchBodyPartOneVehicleInformationType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPartOneVehicleInformation/patchBodyPartOneVehicleInformation.type';

export const patchBodyPartOneVehicleInformationOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchBodyPartOneVehicleInformationType
> => ({
  mutationKey: ['patch-body-part_one-vehicle-information'],
  mutationFn: ({ id, data }: PatchBodyPartOneVehicleInformationType) =>
    patchBodyPartOneVehicleInformationFunction({ data, id }),
});
